<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card shadow="hover" class="mgb20" style="height: 270px; width: 500px;">
                    <div class="user-info">
                        <Avatar :username='nickname' :background-color='extractColorByName(nickname)'
                            color="#fff" :size="120" />

                        <div class="user-info-cont">
                            <div class="user-info-name">{{ nickname }}</div>
                            <div></div>
                        </div>
                    </div>
                    <div style='text-align: center; padding-right: 100px;'>
                        <div class="user-info-list"><span style="font-size: 24px; font-weight: 1000; color:#333">CottonGame</span></div>
                        <div class="user-info-list"><span style="font-size: 16px; color:#333">欢迎登录胖布丁后台</span></div>
                        <div class="user-info-list" v-show="this.pwd == 'true'"><span style="font-size: 14px; color:red">您当前密码为默认密码，请尽快修改密码</span></div>
                        <div class='token-copy'>
                            <el-button size='mini' type='primary' icon='el-icon-document-copy' @click='copyToken'>
                                复制当前Token
                            </el-button>
                        </div>
                    </div>
                </el-card>
                <!-- 连接 Netty 测试 -->
                <!-- <el-card shadow="hover" class="mgb20" style="height: 270px; width: 500px;">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6}"
                        :disabled="true"
                        v-model="netty.textarea">
                    </el-input>

                    <el-divider></el-divider>

                    <el-input placeholder="请输入内容" v-model="netty.value" @keyup.enter.native="send()" auto-complete="off" class="input-with-select">
                        <el-button @click="send()" slot="append" icon="el-icon-position"></el-button>
                    </el-input>
                </el-card> -->
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Avatar from 'vue-avatar';
import { copyContent } from '@/utils/string/cottonPlugin';
import { EnumLocalStore } from '@/constant/enums';
import { localStg } from '@/utils/storage/local'; // 头像
export default {
    name: 'dashboard',
    data() {
        return {
            nickname: localStorage.getItem('ms_nickname'),
            pwd: false,  // 临时判断密码是否是默认密码

            socket: '',
            netty: {
                url: 'ws://127.0.0.1:1010/websocket',
                value: '',
                textarea: ''
            },
        };
    },
    components: {
        Avatar
    },
    created() {
        this.pwd = localStorage.getItem('pwdFlag')  // 临时判断密码是否是默认密码
        //this.init();
    },
    activated() {
        this.pwd = localStorage.getItem('pwdFlag')  // 临时判断密码是否是默认密码
    },
    methods: {
        // 传入名字生成颜色
        extractColorByName(name) {
            var temp = [];
            temp.push("#");
            for (let index = 0; index < name.length; index++) {
                temp.push(parseInt(name[index].charCodeAt(0), 10).toString(16));
            }
            return temp.slice(0, 5).join('').slice(0, 4);
	    },
        
        init() {
            // 实例化socket
            this.socket = new WebSocket(this.netty.url)

            /**
             * 成功
             */
            this.socket.onopen = (message) => {
                this.$message({
                    message: '聊天室连接成功',
                    type: 'success'
                });
            }
            
            /**
             * 失败
             */
            this.socket.onerror = (message) => {
                this.$message({
                    message: '聊天室连接失败',
                    type: 'warning'
                });
            }
            
            /**
             * 返回信息
             */
            this.socket.onmessage = (message) => {
                this.netty.textarea += message.data + '\n';
            }
            
            this.socket.onclose = (message) => {
                console.log(message)
                console.log('socket 关闭~')
            }
        },

        
        /**
         * 发送消息
         */
        send() {
            // 判断消息不为空
            if (this.netty.value != undefined) {
                // 判断连接是否为开启状态
                if (this.socket.readyState != WebSocket.OPEN) {
                    this.$message({
                        message: '连接没有开启',
                        type: 'warning'
                    });
                    return false;
                }
                
                //发送消息
                this.socket.send(this.netty.value)
            }

            this.netty.value = ''
        },
        
        copyToken() {
            const token = localStg.get(EnumLocalStore.jwtTokenName);
            if (!token) {
                this.$message({
                    message: '当前未获取到Token，请重新登录后再复制',
                    type: 'warning'
                });
                return;
            }
            
            copyContent(token);
        }
    }
};
</script>

<style scoped>

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}
.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}
.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}
.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}
.user-info-list span {
    margin-left: 70px;
}

.token-copy {
    margin-top: 10px;
    padding-left: 70px;
}
.mgb20 {
    margin-bottom: 20px;
}
</style>
